import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';
import { AllDevicesButton } from '../AccountSection/AccountSection.styles';

/**
 * The red CTA: Account's "Log out of all devices" control as-is, plus its disabled look for
 * `aria-disabled`. The busy state uses `aria-disabled` (not `disabled`) so the button keeps focus
 * while sending: a `disabled` button drops focus to the page, and the popup would then hand focus
 * back to the page instead of to this button. Only the hover glow is suppressed; the keyboard
 * focus ring stays.
 */
export const DeleteRequestButton = styled(AllDevicesButton)`
  &[aria-disabled='true'] {
    cursor: default;
    opacity: 0.5;
  }

  &[aria-disabled='true']:hover {
    background: transparent;
  }

  &[aria-disabled='true']:hover::before,
  &[aria-disabled='true']:hover::after {
    opacity: 0;
  }
`;

/** The card's explanation, between its SectionTitle and the CTA footer. */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** A muted explanatory paragraph (styled like AccountSection's PasswordCopy); also the popup's body line. */
export const Copy = styled(Text)`
  display: block;
  margin: ${SPACE[0]};
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** "What we delete": a small heading over the list, set a step apart from the intro above it. */
export const Subheading = styled(Text)`
  display: block;
  margin: ${SPACE[4]} ${SPACE[0]} ${SPACE[0]};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${COLORS.text};
`;

/** What gets deleted: a real bulleted list, indented so the bullets sit inside the card's text column. */
export const BulletList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  margin: ${SPACE[0]};
  padding: ${SPACE[0]} ${SPACE[0]} ${SPACE[0]} ${SPACE[20]};
  list-style: disc;
`;

export const BulletItem = styled.li`
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** The failure line under the CTA; announced as an alert when it appears. */
export const ErrorSlot = styled.div`
  text-align: center;
`;

export const ErrorText = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  color: ${COLORS.statusDanger};
`;
